import { createStyles, rem } from '@mantine/core';
import bgDesktop from '../../../assets/images/bgDesktop.png';
import bgMobile from '../../../assets/images/bgMobile.png';
import { body_min_height } from '../../../utils/const.js';
const useStyles = createStyles((theme) => ({
  wrapper: {
    background: 'rgb(224,244,245,0.5)',
    paddingBottom: 100,
    paddingTop: 50,
    backgroundImage: `url(${bgDesktop})`,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat',
    [theme.fn.smallerThan(800)]: {
      backgroundImage: 'none'
    },
    [theme.fn.largerThan(786)]: {
      minHeight: `${body_min_height.desktop} !important`
    }
  },

  header: {
    backgroundColor: 'transparent',
    justifyContent: 'space-around',
    margin: '0 !important',

    [theme.fn.smallerThan('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  formWrapper: {
    paddingLeft: rem(100),

    [theme.fn.smallerThan('sm')]: {
      paddingLeft: rem(0)
    }
  },
  formContainer: {
    backgroundColor: 'transparent',
    [theme.fn.largerThan('xs')]: {
      paddingLeft: '80px'
    }
  },
  form: {
    maxWidth: rem(700),
    paddingTop: rem(10),

    [theme.fn.smallerThan('sm')]: {
      maxWidth: '100%'
    },
    backgroundColor: 'transparent'
  },

  title: {
    color: `${theme.colors.secondary[0]}`,
    fontFamily: `Poppins CF, ${theme.fontFamily}`,
    fontSize: '60px',
    marginLeft: '-120px',
    [theme.fn.smallerThan('sm')]: {
      display: 'contents'
    }
  },
  textInput: {
    background: '0 0',
    color: 'white',
    borderBottom: `1.5px solid ${theme.colors.text[1]}`,
    paddingBottom: '0px',
    paddingLeft: '0px',
    marginBottom: '0px'
  },
  text: {
    fontFamily: `Regular, ${theme.fontFamily}`,
    fontWeight: '400',
    paddingRight: '15px'
  },
  loginButton: {
    backgroundColor: `${theme.colors.secondary[0]}`
  },
  signupButton: {
    backgroundColor: `${theme.colors.primary[0]}`,
    [theme.fn.smallerThan('xs')]: {
      width: rem(270),
      textAlign: 'center'
    }
  },
  loginWrapper: {
    display: 'flex',
    justifyContent: 'end',

    [theme.fn.smallerThan('sm')]: {
      display: 'none'
    }
  },
  tnc: {
    fontWeight: '500'
  },
  loginWrapperMobile: {
    [theme.fn.largerThan('xs')]: {
      display: 'none'
    }
  },
  loginButtonMobile: {
    width: rem(270),
    margin: 'auto'
  },
  loader: {
    position: 'fixed',
    top: '50%',
    left: '40%',
    zIndex: '1000',

    [theme.fn.largerThan('xs')]: {
      left: '23%'
    }
  },
  tableContainer: {
    width: '80%',
    margin: 'auto',
    [theme.fn.smallerThan(1400)]: {
      width: '90%'
    },
    [theme.fn.smallerThan(1050)]: {
      width: '95%',
      overflowX: 'scroll'
    }
  },
  table: {
    backgroundColor: theme.colors.background[0],
    width: '100%',
    margin: 'auto',
    marginTop: 20,
    marginBlock: 20,
    tbody: {
      tr: {
        ':last-child': {
          td: {
            ':first-child': {
              borderBottomLeftRadius: 16
            },
            ':last-child': {
              borderBottomRightRadius: 16
            }
          }
        }
      }
    },
    [theme.fn.smallerThan(1050)]: {
      width: 1200
    },
    [theme.fn.smallerThan(800)]: {
      width: 800
    }
  },
  headerAndSearch: {
    width: '80%',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.fn.smallerThan(1400)]: {
      width: '90%'
    },
    [theme.fn.smallerThan(1050)]: {
      width: '95%'
    },
    [theme.fn.smallerThan(800)]: {
      flexDirection: 'column',
      alignItems: 'center',
      rowGap: 20,
      padding: 10
    }
  },
  searchAndFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 20,

    [theme.fn.smallerThan(800)]: {
      width: '100%',
      marginTop: 10
    }
  },

  searchIcon: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 99,
    width: 16,
    height: 16
  },
  searchInput: {
    width: 472,
    height: 48,
    border: 'none !important',
    [theme.fn.smallerThan(800)]: {
      width: 279,
      height: 48
    },
    input: {
      border: 'none',
      borderRadius: 16,
      fontSize: 16,
      color: theme.colors.text[1],
      fontFamily: `Regular, ${theme.fontFamily}`,
      height: 50,
      [theme.fn.smallerThan(800)]: {
        fontSize: 16,
        height: 50
      }
    }
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 10,
    background: 'white',
    borderRadius: 16,
    paddingLeft: 10,
    paddingRight: 10,
    height: 48,
    width: 111,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.fn.smallerThan(500)]: {
      width: 35,
      height: 35,
      borderRadius: 10
    },
    [theme.fn.smallerThan(800)]: {
      width: 48,
      height: 48,
      borderRadius: 16,
      justifyContent: 'center'
    }
  },

  link: {
    textDecoration: 'none',
    [theme.fn.smallerThan(800)]: {
      display: 'none'
    }
  },
  linkMobile: {
    textDecoration: 'none',
    [theme.fn.smallerThan(800)]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  filterIcon: {
    width: 12,
    height: 12
  },
  filter: {
    fontFamily: `Regular, ${theme.fontFamily}`,
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: '0.15px',
    fontWeight: 400,
    color: theme.colors.text[1],

    [theme.fn.smallerThan(500)]: {
      display: 'none'
    }
  },

  title: {
    fontFamily: `Medium, ${theme.fontFamily}`,
    fontSize: 26,
    fontWeight: 500,
    color: theme.colors.secondary[0]
  },
  tableHead: {
    backgroundColor: theme.colors.secondary[0],
    height: 50
  },
  columnHeading: {
    color: 'white !important',
    fontFamily: `SemiBold, ${theme.fontFamily}`,
    letterSpacing: 0.15,
    fontSize: '13px !important',
    fontWeight: 600,
    lineHeight: '24px',
    whiteSpace: 'nowrap', // 👈 This prevents text wrapping
    ':first-child': {
      borderTopLeftRadius: 10,
      paddingLeft: 25
    },
    ':last-child': {
      borderTopRightRadius: 10
    }
  },
  tableRowWhite: {
    height: 70,
    background: 'white',
    border: 'none'
  },
  tableRow: {
    height: 70,
    background: '#F1F6F6'
  },
  tableData: {
    borderTop: 'none !important',
    fontFamily: `Regular , ${theme.fontFamily}`,
    color: theme.colors.text[1],
    fontSize: 16,
    ':first-child': {
      paddingLeft: 25,
      width: 200,
      [theme.fn.smallerThan(800)]: {
        width: 270,
        flex: '0 0 auto'
        // marginRight: 10,
      }
    },
    ':nth-child(3)': {
      flex: '0 0 auto',
      width: 250
    },
    ':last-child': {
      flex: '0 0 auto',
      width: 150,
      [theme.fn.smallerThan(800)]: {
        flex: '0 0 auto'
      }
    }
  },

  subtableData: {
    borderTop: 'none !important',
    fontFamily: `Regular , ${theme.fontFamily}`,
    color: theme.colors.text[1],
    fontSize: 16,
    ':first-child': {
      paddingLeft: 20,
      width: 350,
      [theme.fn.smallerThan(800)]: {
        width: 270,
        flex: '0 0 auto'
        // marginRight: 10,
      }
    },
    ':nth-child(3)': {
      flex: '0 0 auto',
      width: 250
    },
    ':last-child': {
      flex: '0 0 auto',
      width: 150,
      [theme.fn.smallerThan(800)]: {
        flex: '0 0 auto'
      }
    }
  },
  privateText: {
    borderTop: 'none !important',
    fontFamily: `SemiBold , ${theme.fontFamily}`,
    color: theme.colors.secondary[0],
    fontWeight: 600,
    letterSpacing: '0.15px',
    fontSize: 16
  },
  editAndView: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'left',
    columnGap: 35
  },
  action: {
    width: 20,
    height: 20,
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.2)'
    }
  },
  inaction: {
    opacity: 0.5
  },
  status: {
    fontFamily: `SemiBold , ${theme.fontFamily}`,
    fontWeight: 600,
    width: 140,
    textAlign: 'center',
    padding: 8,
    fontSize: 12,
    borderRadius: 10,
    letterSpacing: '0.25px'
  },
  active: {
    background: theme.colors.background[4],
    color: '#64B216'
  },
  inactive: {
    background: '#F5DBDB',
    color: theme.colors.text[5]
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    border: 'none !important',
    marginTop: 50,
    button: {
      border: 'none !important',
      backgroundColor: 'transparent'
    }
  }
}));
export default useStyles;
